"use client"

export const COLOR = {
    // primary: "#aa2c29",
    primary: "#ea6608",
    secondary: "#ea6608",
    default: "#2e211b",
}